<template>
  <b-form-group
    label="Vergi No"
    label-for="tax_no"
  >
    <validation-provider
      #default="{ errors }"
      name="Vergi No"
      rules="required"
    >
      <b-form-input
        id="tax_no"
        v-model="dataItem.tax_no"
        placeholder="Vergi No"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'TaxNo',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['configCompany/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
